/**
 * Filial Profile — read-only per-loja overview module.
 *
 * Both routes gate on lojas:read since the data is just a re-projection
 * of what the user already has access to via /lojas. Future tabs will
 * gate per-tab on Cofre permissions.
 */

import { lazy } from "react";

import { ModuleRoutes } from "../types";


const FiliaisList = lazy(() => import("@/pages/filial/FiliaisList"));
const FilialOverview = lazy(() => import("@/pages/filial/FilialOverview"));
const FloorPlansList = lazy(() => import("@/pages/filial/FloorPlansList"));
const FloorPlanEditor = lazy(() => import("@/pages/filial/FloorPlanEditor"));
const FloorPlanViewer = lazy(() => import("@/pages/filial/FloorPlanViewer"));
const TopologiesList = lazy(() => import("@/pages/filial/TopologiesList"));
const TopologyEditor = lazy(() => import("@/pages/filial/TopologyEditor"));
const TopologyViewer = lazy(() => import("@/pages/filial/TopologyViewer"));


export const filialRoutes: ModuleRoutes = {
  moduleId: "filial-profile",
  basePath: "/filial",
  routes: [
    {
      path: "/filial",
      element: <FiliaisList />,
      permission: { resource: "lojas", action: "read" },
    },
    {
      path: "/filial/:id",
      element: <FilialOverview />,
      permission: { resource: "lojas", action: "read" },
    },
    {
      path: "/filial/:lojaId/mapa-fisico",
      element: <FloorPlansList />,
      permission: { resource: "lojas", action: "read" },
    },
    {
      path: "/filial/:lojaId/mapa-fisico/:planId",
      element: <FloorPlanEditor />,
      permission: { resource: "lojas", action: "update" },
    },
    {
      // Read-only twin of the editor route. Viewers with only
      // `lojas:read` reach here from the "Visualizar" link in the list.
      path: "/filial/:lojaId/mapa-fisico/:planId/visualizar",
      element: <FloorPlanViewer />,
      permission: { resource: "lojas", action: "read" },
    },
    {
      path: "/filial/:lojaId/topologia",
      element: <TopologiesList />,
      permission: { resource: "lojas", action: "read" },
    },
    {
      path: "/filial/:lojaId/topologia/:topId",
      element: <TopologyEditor />,
      permission: { resource: "lojas", action: "update" },
    },
    {
      path: "/filial/:lojaId/topologia/:topId/visualizar",
      element: <TopologyViewer />,
      permission: { resource: "lojas", action: "read" },
    },
  ],
};
